import './documentUploads.css';
import React, { useRef, useState } from 'react';
import { uploadImage } from '../../Apiservices/Auth/servers/venueServices';
import config from '../../config';
import { contractFileError } from '../documents/contractValidation';

export default function OptionalContractUpload({ fileId, onChange, onUploadingChange }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const input = useRef(null);
  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    setError('');
    const validationError = contractFileError(file);
    if (validationError) {
      setError(validationError);
      return;
    }
    setUploading(true);
    onUploadingChange(true);
    try {
      const id = await uploadImage(file);
      if (!id) throw new Error('Upload failed. Please try again.');
      onChange(id);
    } catch (err) {
      setError(err.message || 'Unable to upload contract.');
    } finally {
      setUploading(false);
      onUploadingChange(false);
    }
  };
  return (
    <div className="form-section">
      <label className="section-label">Contract (PDF) — Optional</label>
      <p>Customers can view this contract before booking.</p>
      <input ref={input} type="file" accept=".pdf,application/pdf" onChange={upload} hidden />
      {fileId && <p><a href={`${config.API_BASE_URL}/gallery/download/${encodeURIComponent(fileId)}?isDownload=false`} target="_blank" rel="noopener noreferrer">View contract PDF</a></p>}
      <button type="button" className="document-upload-button" disabled={uploading} onClick={() => input.current.click()}>
        {uploading ? 'Uploading...' : fileId ? 'Replace PDF' : 'Upload PDF'}
      </button>
      {fileId && <button type="button" disabled={uploading} onClick={() => onChange(null)}>Remove</button>}
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
